import React from 'react'
import '../stylings/navbar.css'
import { Link, NavLink } from 'react-router-dom'

const Navbar = () => {
    return (
        <nav className="vj-navbar navbar navbar-expand-lg sticky-top2" role="navigation" aria-label="Main Navigation">
            <div className="container">

                {/* Mobile: toggler + school name */}
                <div className="vj-mobile-brand">
                    <button
                        className="navbar-toggler vj-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNavDropdown"
                        aria-controls="navbarNavDropdown"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="vj-toggler-bar"></span>
                        <span className="vj-toggler-bar"></span>
                        <span className="vj-toggler-bar"></span>
                    </button>
                    <span className="vj-mobile-name d-lg-none">Vidya Jain Convent School</span>
                </div>

                <div className="collapse navbar-collapse vj-collapse" id="navbarNavDropdown">
                    <ul className="navbar-nav vj-nav">

                        <li className="nav-item">
                            <NavLink className="vj-link" to="/" end>
                                <i className="fa-solid fa-house"></i>
                                <span>Home</span>
                            </NavLink>
                        </li>

                        <li className="nav-item dropdown">
                            <Link className="vj-link vj-link--drop" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fa-solid fa-school"></i>
                                <span>About Us</span>
                                <i className="fa-solid fa-chevron-down vj-caret"></i>
                            </Link>
                            <ul className="vj-dropdown">
                                <li>
                                    <Link className="vj-drop-item" to="/about-school">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-info-circle"></i></span>
                                        About School
                                    </Link>
                                </li>
                                <li>
                                    <Link className="vj-drop-item" to="/public-disclosure">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-file-lines"></i></span>
                                        Mandatory Public Disclosure
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <Link className="vj-link vj-link--drop" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fa-solid fa-book-open"></i>
                                <span>Academics</span>
                                <i className="fa-solid fa-chevron-down vj-caret"></i>
                            </Link>
                            <ul className="vj-dropdown">
                                <li>
                                    <Link className="vj-drop-item" to="#">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-chalkboard-user"></i></span>
                                        Faculty
                                    </Link>
                                </li>
                                <li>
                                    <Link className="vj-drop-item" to="#">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-receipt"></i></span>
                                        Fee Structure
                                    </Link>
                                </li>
                                <li>
                                    <Link className="vj-drop-item" to="#">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-list-check"></i></span>
                                        Curriculum
                                    </Link>
                                </li>
                                <li>
                                    <Link className="vj-drop-item" to="#">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-calendar-days"></i></span>
                                        PTM Schedule
                                    </Link>
                                </li>
                                <li>
                                    <Link className="vj-drop-item" to="#">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-star"></i></span>
                                        Activities
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <Link className="vj-link vj-link--drop" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fa-solid fa-user-graduate"></i>
                                <span>Students</span>
                                <i className="fa-solid fa-chevron-down vj-caret"></i>
                            </Link>
                            <ul className="vj-dropdown">
                                <li>
                                    <Link className="vj-drop-item" to="/syllabus">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-book"></i></span>
                                        Syllabus
                                    </Link>
                                </li>
                                <li>
                                    <Link className="vj-drop-item" to="/time-table">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-clock"></i></span>
                                        Time Table
                                    </Link>
                                </li>
                                <li>
                                    <Link className="vj-drop-item" to="/noticeall">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-bell"></i></span>
                                        Notice Board
                                    </Link>
                                </li>
                                <li>
                                    <Link className="vj-drop-item" to="/audionoticeall">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-volume-high"></i></span>
                                        Audio Announcement
                                    </Link>
                                </li>
                                <li>
                                    <Link className="vj-drop-item" to="/academic-calender">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-calendar-check"></i></span>
                                        Academic Calendar
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <Link className="vj-link vj-link--drop" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="fa-solid fa-images"></i>
                                <span>Gallery</span>
                                <i className="fa-solid fa-chevron-down vj-caret"></i>
                            </Link>
                            <ul className="vj-dropdown">
                                <li>
                                    <Link className="vj-drop-item" to="/galleryall">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-camera"></i></span>
                                        Photo Gallery
                                    </Link>
                                </li>
                                <li>
                                    <Link className="vj-drop-item" to="/videoall">
                                        <span className="vj-drop-icon"><i className="fa-solid fa-film"></i></span>
                                        Video Gallery
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li className="nav-item">
                            <NavLink className="vj-link" to="/contact">
                                <i className="fa-solid fa-phone"></i>
                                <span>Contact</span>
                            </NavLink>
                        </li>

                        <li className="nav-item vj-pd-item">
                            <NavLink className="vj-pd-btn" to="/public-disclosure">
                                <i className="fa-solid fa-shield-halved"></i>
                                <span>Public Disclosure</span>
                            </NavLink>
                        </li>

                    </ul>
                </div>

            </div>
        </nav>
    )
}

export default Navbar
